import React, { useCallback, useContext, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { TAG_CLICK_CONTEXT_MENU } from '../../analytics/analytics.tagids.constants'
import { selectCurrentHistoryRoute } from '../../../store/history/history.selectors'
import { selectMapBbox } from '../../../store/map/map.selectors'
import { selectShouldDisplayContextMenu } from '../../../store/ui/ui.selectors'
import { ACTION } from '../../analytics/ClickTagsService'
import useImpressionTag from '../../analytics/useImpressionTag'
import useEventCallback from '../../utils/useEventCallback'
import { withMapInitialized } from '../map.utils'
import { useEffectWithMapContext, useMapContext } from '../MapContext'
import { CLIC_DROIT } from './contextmenu.constants'
import s from './ContextMenu.less'
import ContextMenuItemItineraryAddStep from './ContextMenuItemItineraryAddStep'
import ContextMenuItemItineraryFrom from './ContextMenuItemItineraryFrom'
import ContextMenuItemItineraryTo from './ContextMenuItemItineraryTo'
import ContextMenuItemShowAddress from './ContextMenuItemShowAddress'
import ContextMenuItemShowCity from './ContextMenuItemShowCity'
import ContextMenuItemShowDepartment from './ContextMenuItemShowDepartment'
import ContextMenuItemShowRegion from './ContextMenuItemShowRegion'

const LocalContext = React.createContext({ point: null })

export const useContextMenu = () => useContext(LocalContext)

export function getStyle(event, canvas) {
  const { clientWidth: canvasWidth, clientHeight: canvasHeight } = canvas

  const width = 160
  const height = 60
  const top = event.point.y
  const left = event.point.x
  return {
    top: top + height > canvasHeight ? top - height : top,
    left: left + width > canvasWidth ? left - width : left,
    width
  }
}

export function ContextMenu() {
  const { map } = useMapContext()
  const currentRoute = useSelector(selectCurrentHistoryRoute)
  const bbox = useSelector(selectMapBbox)
  const [event, setEvent] = useState()
  const shouldDisplay = useSelector(selectShouldDisplayContextMenu)

  const closeContextMenu = useCallback(() => {
    setEvent(null)
  }, [])

  const onContextMenu = useCallback(
    event => {
      setEvent(event)
      map.once('click', closeContextMenu)
    },
    [setEvent, closeContextMenu]
  )

  useEffectWithMapContext(
    map => {
      map.on('contextmenu', onContextMenu)

      return () => {
        map.off('contextmenu', onContextMenu)
      }
    },
    [onContextMenu]
  )

  useEffect(() => closeContextMenu, [currentRoute, bbox, closeContextMenu])
  useImpressionTag(event, { type: TAG_CLICK_CONTEXT_MENU, tagInfo: { [ACTION]: CLIC_DROIT } })

  const menuClickHandler = useEventCallback(closeContextMenu, [closeContextMenu])

  if (!event || !shouldDisplay) return <></>

  return (
    <div className={s.root} style={getStyle(event, map.getCanvas())} onClick={menuClickHandler}>
      <LocalContext.Provider value={{ point: event?.lngLat }}>
        <ContextMenuItemShowAddress />
        <ContextMenuItemShowCity />
        <ContextMenuItemShowDepartment />
        <ContextMenuItemShowRegion />
        <ContextMenuItemItineraryFrom />
        <ContextMenuItemItineraryTo />
        <ContextMenuItemItineraryAddStep />
      </LocalContext.Provider>
    </div>
  )
}

export default withMapInitialized(ContextMenu)
